import React from 'react';
const downArrow = `${process.env.REACT_APP_CDN_URL}/globalAssets/briefview/downArrow.svg`;

const TabsNavigation = ({ 
    TabSelected, 
    handleTabClick, 
    SelectedBrief, 
    SelectedProfessional, 
    isSelectedProActive, 
    setIsSelectedProActive, 
    handleShortlistClick, 
    RemoveShortListed 
}) => {
    const MappedShortListedID = [];
    
    return (
        <div className='TabCotainer'>
            <div className="tab-container">
                <div className="tabs">
                    <div style={{ width: '60%', display: 'flex', justifyContent: 'space-between', flexDirection: 'row', height: '100%', boxShadow: 'rgba(150, 150, 150, 0.26) 0px 3px 0px' }}>
                        <div className={`tab ${TabSelected === 'Info' ? 'active' : ''}`} onClick={() => handleTabClick('Info')}>
                            <p style={{ margin: '0' }}>Info</p>
                        </div>
                        <div className={`tab ${TabSelected === 'ProjectPlan' ? 'active' : ''}`} onClick={() => handleTabClick('ProjectPlan')}>
                            Project Proposal
                        </div>
                        <div className={`tab ${TabSelected === 'Finance' ? 'active' : ''}`} onClick={() => handleTabClick('Finance')}>
                            Finance Details
                        </div>
                        <div className={`tab ${TabSelected === 'Contract' ? 'active' : ''}`} onClick={() => handleTabClick('Contract')}>
                            Contracts
                        </div>
                        <div className={`tab ${TabSelected === 'Meetings' ? 'active' : ''}`} onClick={() => handleTabClick('Meetings')}>
                            Meetings
                        </div>
                    </div>
                    
                    {TabSelected !== 'Contract' && TabSelected !== 'Finance' && (
                        <div className='shortlisted'>
                            <div className='offeringSecShort' style={{ cursor: 'pointer' }} onClick={() => setIsSelectedProActive(!isSelectedProActive)}>
                                <p className='value' style={{ color: SelectedProfessional.status === 'SELECTED' ? '#6D4194' : '#AFAFAF' }}>
                                    {SelectedProfessional.fullName ?? ''}
                                </p>
                                <img src={downArrow} style={{ cursor: 'pointer' }} alt="dropdown" />
                            </div>

                            {isSelectedProActive && (
                                <div className='shortPopup'>
                                    {Array.isArray(SelectedBrief.shortlist) && SelectedBrief.shortlist.length > 0 ? 
                                        SelectedBrief.shortlist.map((item, index) => {
                                            if (item !== null || item !== undefined) {
                                                if (typeof item === 'object') {
                                                    if (Object.keys(item).includes('professional') && typeof item.professional === 'object') {
                                                        if (!MappedShortListedID.includes(item.professional._id)) {
                                                            MappedShortListedID.push(item.professional._id);
                                                            return (
                                                                <>
                                                                    <p 
                                                                        id={item.professional._id} 
                                                                        className='p_onshotlist' 
                                                                        style={{ width: '100%', cursor: 'pointer', height: '100%', margin: '0px' }} 
                                                                        onClick={handleShortlistClick}
                                                                    >
                                                                        {item.professional.firstName} {item.professional.lastName}
                                                                        <span className='delSpan' id={item.professional._id} onClick={RemoveShortListed}>x</span>
                                                                    </p>
                                                                    <hr style={{ marginBottom: '5%', backgroundColor: '#6D4194', minHeight: '0.5px', borderRadius: '50px' }}></hr>
                                                                </>
                                                            );
                                                        }
                                                    }
                                                }
                                            }
                                        }) : (
                                        <p>Not Shortlisted</p>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                <div className={`underline ${TabSelected}`} style={{
                    width:
                        TabSelected === 'Info' ? '3%' :
                        TabSelected === 'ProjectPlan' ? '10.3%' :
                        TabSelected === 'Finance' ? '10.5%' :
                        TabSelected === 'Contract' ? '8%' :
                        TabSelected === 'Meetings' ? '8%' : '0%',
                    transform:
                        TabSelected === 'Info' ? 'translateX(1dvw)' :
                        TabSelected === 'ProjectPlan' ? 'translateX(6.5dvw)' :
                        TabSelected === 'Finance' ? 'translateX(19.25dvw)' :
                        TabSelected === 'Contract' ? 'translateX(30.5dvw)' : 'translateX(35dvw)'
                }}></div>
            </div>
        </div>
    );
};

export default TabsNavigation;